/**
 * Key-value storage adapter (web: localStorage).
 *
 * Async on purpose so the same interface can be backed by AsyncStorage /
 * SecureStore on mobile. Values are strings; a missing key reads as null.
 *
 * Never rejects: a storage error (SecurityError in a locked-down browser,
 * QuotaExceededError) is logged, reads resolve to null and writes resolve.
 * Callers hydrate the app from these reads and fire many writes without
 * awaiting them, so a rejection would leave the hydration gate up or surface
 * as an unhandled rejection.
 */

export const getItem = async (key) => {
  try {
    return window.localStorage.getItem(key);
  } catch (error) {
    console.warn(`storage.getItem('${key}') failed:`, error);
    return null;
  }
};

export const setItem = async (key, value) => {
  try {
    // AsyncStorage rejects non-strings; coerce here so both platforms agree
    window.localStorage.setItem(key, String(value));
  } catch (error) {
    console.warn(`storage.setItem('${key}') failed:`, error);
  }
};

export const removeItem = async (key) => {
  try {
    window.localStorage.removeItem(key);
  } catch (error) {
    console.warn(`storage.removeItem('${key}') failed:`, error);
  }
};

const storage = { getItem, setItem, removeItem };

export default storage;
